module.exports = __webpack_public_path__ + "static/canvas2-72f6606112095b721f40acea21f0334e.png";